import React from "react";
import { Typography, Grid } from "@mui/material";
import DataField from "../Datafield";
import MappedText from "../../reports/create-report/shared-components/mapText";
import { convertDate } from "../../reports/create-report/sections/utils";




export default function AdministrativeInfo({ allDataApis }) {
    return (
      <>
        <Typography variant={"h5"} style={{ fontWeight: "700", marginBottom: "20px" }}>
          <MappedText text={"Administrative Info"} />
        </Typography>
  
        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <DataField title="Creator" value={allDataApis?.dirs?.creator || "NA"} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Creation date"
              value={convertDate(allDataApis?.dirs?.creation_date) || "NA"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Hospital name"
              value={allDataApis?.dirs?.hospital_name || "NA"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Clinical referrer"
              value={allDataApis?.dirs?.clinical_referrer || "NA"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DataField
              title="Clinical referrer contact info"
              value={allDataApis?.dirs?.clinical_referrer_contact || "NA"}
            />
          </Grid>
        </Grid>
      </>
    );
  }